import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { Markdown } from "@/components/molecules/Markdown";
import { LayoutRouter } from "@/layouts/LayoutRouter";
import { PublicLayout } from "@/layouts/PublicLayout";

export default function Page() {
  const { id } = useParams<{ id: string }>();
  const [policy, setPolicy] = useState<string | null>(null);

  // Policies exist in the public/policies folder and are named like this: privacy-policy.md
  useEffect(() => {
    fetch(`/policies/${id}.md`)
      .then((res) => res.text())
      .then((text) => {
        setPolicy(text);
      });
  }, [id]);

  return (
    <LayoutRouter
      isPublicLayout
      isHorizontalPaddingIncluded={false}
      isVerticalPaddingIncluded={false}
      isFooterVisible={true}
      isFooterBorderHidden={true}
      isRulersIncluded={true}
      topbarMaxWidth={"xl"}
    >
      <PublicLayout
        layout={{
          content: [
            {
              type: "custom",
              includePadding: true,
              renderChildren: () => <Markdown>{policy}</Markdown>,
              outerClassName: "pb-16",
            },
          ],
        }}
        maxWidth="lg"
      />
    </LayoutRouter>
  );
}
